import { lazy } from 'react';
import { Navigate } from 'react-router-dom';
import { RouteObject } from 'react-router';

import RoutesLoader from 'src/components/RoutesLoader';

import BaseLayout from 'src/layouts/BaseLayout';
import { isLoggedInOrNot } from 'src/utils/loggedInStatus.utils';

// Pages

const StudentLogin = RoutesLoader(
  lazy(() => import('src/pages/Student/Auth/Login'))
);
const ParentLogin = RoutesLoader(
  lazy(() => import('src/pages/Parent/Auth/Login'))
);
const ParentSignUp = RoutesLoader(
  lazy(() => import('src/pages/Parent/Auth/SignUp'))
);
const ForgotPassword = RoutesLoader(
  lazy(() => import('src/pages/Auth/ForgotPassword'))
);
const VerifyEmail = RoutesLoader(
  lazy(() => import('src/pages/Auth/VerifyEmail'))
);
const ResetPassword = RoutesLoader(
  lazy(() => import('src/pages/Auth/ResetPassword'))
);

// Status

const Status404 = RoutesLoader(
  lazy(() => import('src/components/Status/Status404'))
);
const Status500 = RoutesLoader(
  lazy(() => import('src/components/Status/Status500'))
);
const StatusComingSoon = RoutesLoader(
  lazy(() => import('src/components/Status/ComingSoon'))
);
const StatusMaintenance = RoutesLoader(
  lazy(() => import('src/components/Status/Maintenance'))
);
const NonSubmittedHomeworkResponses = RoutesLoader(
  lazy(
    () =>
      import(
        'src/pages/Student/ActivityManagement/Worksheet/NonSubmittedHomeworkResponses/Index'
      )
  )
);

const AuthenticationRoutes: RouteObject[] = [
  {
    path: '',
    element: <BaseLayout />,
    children: [
      {
        path: '/student-login',
        element: <StudentLogin />
      },
      {
        path: '/parent-login',
        element: <ParentLogin />
      },
      {
        path: '/parent-login/:token',
        element: <ParentLogin />
      },
      {
        path: '/parent-signup',
        element: <ParentSignUp />
      },
      {
        path: '/forgot-password',
        element: <ForgotPassword />
      },
      {
        path: '/verify-email',
        element: <VerifyEmail />
      },
      {
        path: '/reset-password',
        element: <ResetPassword />
      },
      {
        path: '',
        element: <Navigate to="/student-login" replace />
      },
      {
        path: 'status',
        children: [
          {
            path: '',
            element: <Navigate to="404" replace />
          },
          {
            path: '404',
            element: <Status404 />
          },
          {
            path: '500',
            element: <Status500 />
          },
          {
            path: 'maintenance',
            element: <StatusMaintenance />
          },
          {
            path: 'coming-soon',
            element: <StatusComingSoon />
          }
        ]
      },
      {
        path: '*',
        element: isLoggedInOrNot() ? (
          <Status404 />
        ) : (
          <Navigate to="/student-login" replace />
        )
      },
      {
        path: '/homework-submission/:hs_token',
        element: <NonSubmittedHomeworkResponses />
      }
    ]
  }
];

export default AuthenticationRoutes;
